import { render } from "./AdminMobile.vue?vue&type=template&id=fa2b0e12&scoped=true"
import script from "./AdminMobile.vue?vue&type=script&lang=js"
export * from "./AdminMobile.vue?vue&type=script&lang=js"

import "./AdminMobile.vue?vue&type=style&index=0&id=fa2b0e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2b0e12"]])

export default __exports__